import React from 'react';

export default function SimplePulse({ amplitude = 0, isSpeaking, isThinking, size = 64 }) {
    const scale = 1 + amplitude * 0.15;
    const glowSize = 8 + amplitude * 20;
    const glowOpacity = 0.15 + amplitude * 0.35;

    return (
        <div
            className="relative rounded-full transition-transform"
            style={{
                width: size,
                height: size,
                transform: `scale(${scale})`,
                transition: 'transform 0.1s ease-out',
            }}
        >
            {/* Outer glow */}
            <div
                className="absolute inset-0 rounded-full"
                style={{
                    boxShadow: `0 0 ${glowSize}px ${glowSize / 2}px rgba(139, 92, 246, ${glowOpacity})`,
                    transition: 'box-shadow 0.15s ease-out',
                }}
            />
            {/* Main circle */}
            <div
                className="w-full h-full rounded-full"
                style={{
                    background: isThinking
                        ? 'radial-gradient(circle at 35% 35%, #a78bfa, #7c3aed, #5b21b6)'
                        : 'radial-gradient(circle at 35% 35%, #c4b5fd, #8b5cf6, #6d28d9)',
                    animation: isThinking ? 'pulse-soft 1s ease-in-out infinite' : undefined,
                }}
            />
            {/* Highlight */}
            <div
                className="absolute rounded-full"
                style={{
                    top: '15%', left: '20%', width: '30%', height: '25%',
                    background: 'radial-gradient(ellipse, rgba(255,255,255,0.5), transparent)',
                }}
            />
        </div>
    );
}
